"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TabletIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4C7.58172 4 4 7.58172 4 12C4 14.1566 4.85334 16.1139 6.24078 17.5526L16.6995 5.52512C15.3801 4.56583 13.7561 4 12 4ZM12 20C10.4589 20 9.01955 19.5642 7.7985 18.8092L18.1592 6.89437C19.3088 8.27968 20 10.0591 20 12C20 16.4183 16.4183 20 12 20ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM10.67 6.9C10.5521 6.15933 10.5517 6.15939 10.5513 6.15946L10.5504 6.1596L10.5484 6.15993L10.5434 6.16075L10.5298 6.16311C10.5191 6.165 10.5052 6.16754 10.4884 6.17084C10.4548 6.17743 10.4092 6.18702 10.3533 6.2003C10.2418 6.22683 10.0882 6.26838 9.90645 6.3307C9.54499 6.45462 9.05986 6.66488 8.57072 7.01228C7.56614 7.72574 6.59 8.99186 6.59 11.1H8.09C8.09 9.53814 8.77885 8.70427 9.43927 8.23523C9.78263 7.99137 10.13 7.83976 10.3929 7.74962C10.5233 7.70491 10.6299 7.67637 10.7005 7.65958C10.7357 7.65121 10.7616 7.64583 10.7768 7.64286L10.7911 7.64016C10.7921 7.63999 10.7923 7.63996 10.7918 7.64005M10.67 6.9C10.7879 7.64068 10.7883 7.64062 10.7886 7.64056L10.67 6.9ZM10.7886 7.64056L10.7893 7.64045L10.7886 7.64056ZM10.7893 7.64045L10.7904 7.64027L10.7893 7.64045ZM10.7904 7.64027L10.7911 7.64016L10.7904 7.64027Z",
  fill: "currentColor"
}));

var _default = TabletIcon;
exports.default = _default;